"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  appointmentHistory: {
    inVvl: 'IN VVL',
    outVvl: 'OUT VVL',
    blNo: '提单号',
    appointment: '预约时间',
    appointmentNotNull: '预约时间不能为空',
    vesselAndVoyageNotNull: '船名&航次不能为空',
    notSamePort: '请勾选相同的港口',
    notBatchPrint: '非CNTAO、CNSHK暂不支持批量打印',
    searchNotNull: 'IN VVL/OUT VVL/提单号/预约时间从/到 其中一项不能为空',
    notBookedCannotCancel: '未预约不能取消预约',
    cantPrint: 'EDO码空，不可以打印提货单！',
    alreadyExchangedCannotUpdatePickDate: '已换单不能再更改提箱日期'
  },
  appointmentHistoryTable: {
    outVesselCode: '出口船名',
    outVoyageNo: '出口航次',
    outVoyageLeg: '出口航段',
    inVesselCode: '进口船名',
    inVoyageNo: '进口航次',
    inVoyageLeg: '进口航段',
    blNo: '提单号',
    pod: '卸货港',
    deliverableDate: '可换单时间',
    eta: '预计到港时间',
    invoiceTitle: '发票抬头',
    paymentStatus: '付款状态',
    edoSentStatus: 'EDO状态',
    forespeakStatus: '预约状态',
    forespeakDate: '预约时间',
    edoCertifyCode: 'EDO安全码',
    anCode: 'AN验证码',
    print: '打印',
    updatePickCtnDate: '更改提箱日期',
    attachmentAudit: '附件审核状态',
    deliveryReleaseFlag: '是否已换单',
    paymentDate: '核账时间',
    edoSentStatusSh: '换单发送状态',
    accreditSentStatus: '授权发送状态',
    accreditStatus: '授权状态',
    printDO: 'DO打印',
    printBill: '账单',
    printVoyage: '航次证明',
    forespeakNo: '预约号',
    dem: 'DEM',
    foreSpeakInfo: '预约信息',
    downloadFile4AN: '到货通知下载',
    downloadFile4Invoice: '发票下载'
  }
};